import React, { Fragment } from 'react';
import { compose } from 'recompose';
import { connect } from '../../redux/store';
import { refetchActivityFeed } from '@kineticdata/bundle-common';
import { PageTitle } from '../shared/PageTitle';
import { SurveyActivity } from './SurveyActivity';

const feedKey = 'my-surveys-feed';

export const MySurveysComponent = ({ navigate, pageSize, setPageSize }) => (
  <Fragment>
    <div className="page-container">
      <div className="page-panel">
        <PageTitle
          parts={['My Surveys']}
          title={'My Surveys'}
          actions={[
            {
              icon: 'refresh',
              onClick: () => {
                refetchActivityFeed(feedKey);
              },
              aria: 'Reload Surveys',
            },
          ]}
        />
        <div className="cards">
          <SurveyActivity
            feedKey={feedKey}
            navigate={navigate}
            pageSize={pageSize}
            setPageSize={setPageSize}
          />
        </div>
      </div>
    </div>
  </Fragment>
);

const mapStateToProps = (state, props) => ({
  appLocation: state.app.location,
});

export const MySurveys = compose(connect(mapStateToProps))(MySurveysComponent);
